import { omit, pick } from 'lodash-es';

export const popStateData = <T extends object>(keys: readonly (keyof T )[]): Partial<T> => {
  const state = (history.state || {}) as Partial<T>;
  history.replaceState(omit(state, keys), '');
  return pick(state, keys);
};
